/**
 *
 * Tags
 *
 */
import { DataTable } from './components/view-list';
import React, { memo } from 'react';

interface Props {}

export const Tags = memo((props: Props) => {
  return (
    <div>
      <h1>Tags</h1>
      <DataTable />
    </div>
  );
});
